/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ChangelogRoute extends Route {
  // Services
  @service
  heroApi;

  @service
  session;

  @service
  store;

  model(params) {
    let store = this.store;
    let subjectId = params.subject_id;
    let person = this.modelFor('people.person').person;

    return hash({
      person,
      levels: store.query('milestones/level', { goalSubjectId: subjectId }),
      subject: store.findRecord('goals/subject', subjectId),
      categories: store.query('goals/category', { subjectId }),
      goals: store.query('goals/goal', { subjectId }),
      result: store.findRecord('milestones/progression', params.progression_id),
    });
  }

  afterModel(model) {
    let personId = model.person.id;
    let schoolId = this.get('session.activeSchool');
    let subjectId = model.subject.id;
    let asAtTime = model.result.createTime;
    // Progressions use second-resolution timestamps, but goal states use
    // millisecond-resolution timestamps.  Convert and bump by 999ms to
    // capture the full second.
    asAtTime = asAtTime * 1000 + 999;
    return hash({
      summary: this.heroApi.goals.getLearnerSummary(
        schoolId,
        personId,
        subjectId,
        asAtTime,
      ),
    })
      .then((extra) => {
        model.summary = extra.summary;
      })
      .finally(() => {
        // Return the model whether or not we managed to get the summary.
        return model;
      });
  }
}
